module.exports = __webpack_public_path__ + "static/atlanta-ffdf9e049ddeaa1d980110a8e8dd7e6d.png";